/* AUTH */
export const CHECK_AUTH_TYPE = 'CHECK_AUTH_TYPE';
export const CHECK_AUTH_TYPE_SUCCESS = 'CHECK_AUTH_TYPE_SUCCESS';
export const CHECK_AUTH_TYPE_FAILED = 'CHECK_AUTH_TYPE_FAILED';
export const REGISTER_LINKED_ACCOUNT = 'REGISTER_LINKED_ACCOUNT';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const FORGET_PASSWORD_SUCCESS = 'FORGET_PASSWORD_SUCCESS';
export const FORGET_PASSWORD_FAILED = 'FORGET_PASSWORD_FAILED';
export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILED = 'FETCH_USER_PROFILE_FAILED';
export const INIT_AUTH = 'INIT_AUTH';
export const INIT_AUTH_SUCCESS = 'INIT_AUTH_SUCCESS';
export const INIT_AUTH_FAILED = 'INIT_AUTH_FAILED';
